// 图片懒加载指令
const lazyLoad = {
  inserted(el, binding) {
    // 设置默认占位图
    el.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"%3E%3Crect width="100" height="100" fill="%23f0f0f0"/%3E%3C/svg%3E'
    
    // 获取真实图片地址
    const realSrc = binding.value
    
    // 创建 IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 图片进入可视区域，加载真实图片
          const img = entry.target
          img.src = realSrc
          img.onload = () => {
            img.classList.add('lazy-loaded')
          }
          observer.unobserve(img)
        }
      })
    }, {
      rootMargin: '50px', // 提前 50px 开始加载
      threshold: 0.01
    })
    
    observer.observe(el)
    el._lazyObserver = observer
  },
  
  unbind(el) {
    // 清理 observer
    if (el._lazyObserver) {
      el._lazyObserver.disconnect()
    }
  }
}

export default {
  install(Vue) {
    Vue.directive('lazy', lazyLoad)
  }
}


// WEBPACK FOOTER //
// ./src/directives/lazyLoad.js